module.exports = __webpack_public_path__ + "img/logo_community_biobank.11458caf.svg";